import { Vue } from "jupyter-vue";
export default Vue;